module.exports = __webpack_public_path__ + "static/img/四川大学华西医院.6680a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/四川大学华西医院.png
// module id = r0yd
// module chunks = 0 1 2 9